/**
 * Replaces any "Pagar.me" / "Pagarme" / "PagarMe" occurrence with "Stone".
 * Used to Stone-ify page titles (and any brand text) at runtime.
 * No-op for empty/undefined input.
 */
export function toStoneBrand (text) {
  if (!text) return text
  return text.replace(/pagar\.?me/gi, 'Stone')
}
